import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import { Config } from '../../config/config';
import Cookie from 'js-cookie';
const config = JSON.parse(Config);

export const NC_DATE_GRID = async (url, fromDate, toDate, storeId) => {
  const fetchedData = await ApiGateWay.Get(
    config['api'] +
      url +
      '?fromDate=' +
      fromDate +
      '&toDate=' +
      toDate +
      '&storeId=' +
      storeId
  )
    .then((response) => response.json())
    .then((response) => {
      if (
        response.errorMessage === 'Token Expired' ||
        response.errorMessage === 'Invalid Token:::JWT expired' ||
        response.errorMessage ===
          'Your session has expired. Please login again.'
      ) {
        Cookie.remove('currentUser');
        Cookie.remove('stores');
        Cookie.remove('storesAll');
        Cookie.remove('warehouses');

        localStorage.clear();
        sessionStorage.clear();

        return (window.location = '/');
      }
      let body = [];
      let stores = [];
      let colorCodes = [];
      let storeID = [];
      let proxyjson = [];

      response.nonConfirmityInfo.map((name, val) => {
        body.push([
          name.ncStatus,
          name.ncDueDate,
          name.ncCreatedDate,
          name.ncCreatedBy,
          name.ncAssignedTo,
          name.ncSource,
          name.comments,
        ]);
        stores.push(name.description);
        storeID.push(name.description);
        colorCodes.push([0, 0, 0, 0, 0, 0, 0, 0]);
      });

      return (proxyjson = {
        type: 'NCDateGrid',
        thead: [
          'Description',
          'NC Status',
          'NC DueDate',
          'NC Created Date',
          'NC Created By',
          'NC Assigned To',
          'NC Source',
          'Comments',
        ],
        storeId: storeID,

        tbody: body,
        columns: [
          'Description',
          'NC Status',
          'NC DueDate',
          'NC Created Date',
          'NC Created By',
          'NC Assigned To',
          'NC Source',
          'Comments',
        ],
        stores: stores,
        colorCodes: colorCodes,
        popUpDataGrid: body,
        popUpDataGridHeaders: ['Not Required'],
        excelData: response.nonConfirmityInfo,
      });
    });
  return fetchedData;
};
